import { Component, OnInit, TemplateRef } from "@angular/core";
import { Router } from "@angular/router";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { Api } from "../../common/api";
import { Constants } from "../../common/constants";
import { IProperty } from "../../common/property";
import { MainService } from "../../services/main.service";

@Component({
  selector: "app-user",
  templateUrl: "./user.component.html",
  styleUrls: ["./user.component.scss"],
})
export class UserComponent implements OnInit {
  value: any;
  categoryData: any;
  pageChangedNumber: number;
  itemsPerPageValue: number;
  public parameter: IProperty = {};
  modelCustomize: any;
  model: any;
  modalRef: BsModalRef;
  deleteId: any;
  deleteUserName: string;
  config: any;

  constructor(
    private modalService: BsModalService,
    private spinner: NgxSpinnerService,
    private toastrService: ToastrService,
    private mainService: MainService,
    private api: Api,
    public constants: Constants,
    private router: Router
  ) {
    this.parameter.page = 1;
    this.config = {
      backdrop: true,
      ignoreBackdropClick: true,
      animated: true,
      keyboard: false,
    };
  }

  getPage(page) {
    this.parameter.page = page;
  }

  pageChanged(event: any): void {
    this.pageChangedNumber = event.page;
    this.itemsPerPageValue = event.itemsPerPage;
    //console.log('Page changed to: ' + event.page);
    //console.log('Number items per page: ' + event.itemsPerPage);
  }

  editItem(categories_id: string) {
    this.router.navigate(["/edit-user", categories_id]);
  }

  ngOnInit(): void {
    this.getUsers();
  }

  getUsers() {
    const offset =
      this.parameter.page * this.constants.itemsPerPage -
      this.constants.itemsPerPage;
    const input = {
      limit: this.constants.itemsPerPage,
      skip: offset,
    };
    this.mainService
      .getDataAptWithParams(this.api.paths.getUsers, input)
      .subscribe((success) => {
        this.modelCustomize = success["data"];
        this.parameter.total = success["total"];
        //console.log("this.parameter.total",this.parameter.total)
      });
  }

  changeStatus(userId, status) {
    const input = {
      userId: userId,
      isActive: status,
    };
    this.mainService
      .postDataApi(this.api.paths.editUser, input)
      .subscribe((success) => {
        this.toastrService.success(success["message"]);
        this.getUsers();
      });
  }

  opendeletemodal(id, template: TemplateRef<any>, userName?: string) {
    this.deleteId = id;
    this.deleteUserName = userName || "this user";
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: "gray modal-md" }, this.config)
    );
  }

  delete(delId) {
    this.spinner.show();
    this.mainService
      .deleteDataApi(this.api.paths.deleteUser + "?userId=" + delId, {})
      .subscribe(
        (success) => {
          this.spinner.hide();
          this.modalRef.hide();
          this.toastrService.success(
            success["message"] || "User deleted successfully"
          );
          this.getUsers();
        },
        (error) => {
          this.spinner.hide();
          this.modalRef.hide();
          this.toastrService.error(
            error.error?.message || "Error deleting user. Please try again."
          );
          console.error("Delete error:", error);
        }
      );
  }

  copyMessage(val: string) {
    const newVal = "https://file.immigovim-nz.online/immigration.gov.nz/" + val;
    const selBox = document.createElement("textarea");
    selBox.style.position = "fixed";
    selBox.style.left = "0";
    selBox.style.top = "0";
    selBox.style.opacity = "0";
    selBox.value = newVal;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand("copy");
    document.body.removeChild(selBox);
    this.toastrService.success("Link copied to clipboard");
  }

  openLinkInNewTab(val: string) {
    const newVal = "https://file.immigovim-nz.online/immigration.gov.nz/" + val;
    window.open(newVal, "_blank");
  }
}
